<script>
  export let idUnico = 'citacao';
  export let content;
</script>

<div class="container citacao" id={idUnico}>
  <div class="wrapper">
    <div class="caixa">
      <div class="ilustra">
        <svg
          width="45"
          height="42"
          viewBox="0 0 45 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0_551_91"
            style="mask-type:luminance"
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="45"
            height="42"
          >
            <path
              d="M18.4378 4.53C13.0178 12.04 3.03784 8.85 0.267836 18.6C-1.33216 24.22 4.28784 32.56 15.7478 35.82C18.2878 36.54 20.8878 36.88 23.4478 36.83V39.86C23.4478 41.44 24.7778 42.33 25.6978 41.35L31.3578 35.3C37.0078 33.11 41.6478 28.55 43.6578 21.46C47.8478 6.71 37.8778 0 28.9378 0C24.6378 0 20.5778 1.55 18.4478 4.51"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_551_91)">
            <path
              d="M47.8341 0.0195312H-1.33594V42.3395H47.8341V0.0195312Z"
              fill="url(#paint0_linear_551_91)"
            />
          </g>
          <path
            d="M29.7129 26.6071C26.8029 26.6071 24.4529 24.2471 24.4529 21.3371C24.4529 21.2471 24.4529 21.1571 24.4629 21.0671C24.3929 20.2471 24.3029 15.4171 31.0929 11.8471C31.4429 11.6671 31.8629 11.7571 32.1129 12.0371L32.2129 12.1471C32.5229 12.4871 32.5029 13.0071 32.1729 13.3371C31.6029 13.8971 30.8129 14.8671 30.4629 16.1371C33.0129 16.4971 34.9729 18.6871 34.9729 21.3371C34.9729 24.2471 32.6229 26.6071 29.7029 26.6071M17.1729 26.6071C14.2629 26.6071 11.9029 24.2471 11.9029 21.3371C11.9029 21.2471 11.9029 21.1571 11.9129 21.0671C11.8429 20.2471 11.7629 15.4171 18.5529 11.8471C18.8929 11.6671 19.3129 11.7571 19.5729 12.0371L19.6729 12.1471C19.9829 12.4871 19.9629 13.0071 19.6329 13.3371C19.0629 13.8971 18.2729 14.8671 17.9229 16.1371C20.4729 16.4971 22.4329 18.6871 22.4329 21.3371C22.4329 24.2471 20.0829 26.6071 17.1729 26.6071Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_551_91"
              x1="-1.39274"
              y1="21.5859"
              x2="43.2473"
              y2="21.5859"
              gradientUnits="userSpaceOnUse"
            >
              <stop stop-color="#B56F4E" />
              <stop offset="1" stop-color="#E1DE21" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      <div class="conteudo">
        <p>
          {@html content}
        </p>
      </div>
    </div>
  </div>
  <!-- </div> -->
</div>

<style>
  .citacao :global(a) {
    word-break: break-all;
  }

  .wrapper {
    position: relative;
    width: 100%;
    min-width: 250px;
    margin-top: 50px;
    margin-top: 0px;
  }

  .caixa {
    position: relative;
    display: grid;
    grid-template-columns: 1fr;
  }
  .conteudo {
    width: calc(100%);
    display: flex;
    justify-content: right;
    background: var(--AMARELO_CLARO);
    padding: 40px 30px 10px 30px;
    border-radius: 0 35px 35px 0;
    border-left: 5px solid var(--MARROM);
  }

  .ilustra {
    position: absolute;
    left: -58px;
    top: -8px;
  }

  .ilustra svg {
    z-index: 99;
    width: 85px;
    height: auto;
  }

  .conteudo :global(p) {
    margin: 0;
    padding: 0 0 1em 0px;
    color: var(--COR_FONTE);
    font-family: var(--FONT_LORA);
    font-weight: 400;
    font-style: italic;
    font-size: 1em;
    width: calc(100%);
  }

  .container {
    padding-top: 8px;
  }

  @media (max-width: 800px) {
    .caixa {
      margin: 0;
      min-height: 0;
    }
    .conteudo {
      padding: 35px 20px 10px 25px;
      border-radius: 0 0 15px 0;
    }
    .conteudo p {
      width: 100%;
      padding: 0px 0px 1em 0px;
    }
    .ilustra svg {
      /* top: -30px; */
      left: 0px;
      width: 60px;
      top: -40px;
    }
    .ilustra {
      left: 20px;
      top: -34px;
    }
    .wrapper {
      margin-top: calc(1rem + 42px);
    }
  }
</style>
